"use client"

import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { getEnvSetup } from "../utils/getEnvSetup"
import { Provider } from "./EnvContext"

export default function EnvProviderPages({
  children,
}: {
  children: React.ReactNode
}) {
  const router = useRouter()
  const [env, setEnv] = useState<ReturnType<typeof getEnvSetup> | null>(null)

  useEffect(() => {
    setEnv(getEnvSetup(location))
  }, [router.asPath])

  if (!env) return null

  return (
    <Provider
      value={{
        ...env,
        router: {
          push: (path, options) => router.push(path, undefined, options),
          replace: (path, options) => router.replace(path, undefined, options),
          back: router.back,
          forward: router.forward,
          query: router.query,
          pathname: router.asPath,
        },
      }}
    >
      {children}
    </Provider>
  )
}
